import { getStorage, getUserGroupData } from './browserStorage';
import {LOGIN_AFFILIATE_GROUP, LOGIN_SUPER_ADMIN_GROUP, LOGIN_CLIENT_GROUP} from '../configs/staticConfigs';
import {userGroupUrlCheck} from './userGroupUrlCheck'
const permissionList = ["settings","crew-profile",
                        "client-profile","profile",
                        "logs","associates","clients","crews",
                        "quotes","schedule-view","schedule-shift",
                        "unavailability","timesheet","events",
                        "affiliates","affiliate-profile",
                        "feedback"]
const settingArray = ["skills","client-docs",
							"crew-docs","dynamic-fields-crew",
							"dynamic-fields-clients","event-locations",
							"key-locations","departments",
							"other-expenses","roles-permissions",
							"invite-friend","csv-templates","pay-levels",
							"rate-card","certificates", "sectors",
                            "sub-sectors", "dynamic-fields-affiliates",
                            "omnu-points", "omnu-point-settings",
                            "cancel-reasons", "terms"
                            ]
const moduleObject = {"crew-profile":"crew",
                        "client-profile":"client",
                        "profile":"companyprofile",
                        "logs":"logs",
                        "associates":"associateusers",
                        "affiliates":"affiliate",
                        "affiliate-profile":"affiliate",
                        "clients":"client",
                        "quotes":"quotes",
                        "events":"events",
                        "crews":"crew",
                        "schedule-view":"schedule",
                        "schedule-shift":"schedule",
                        "unavailability":"crewunavailability",
                        "feedback":"feedback",
                        "timesheet":"timesheet",
                        "event-locations":"eventlocations",
                        "key-locations":"keylocations",
                        "departments":"settingsdepartments",
                        "roles-permissions":"rolesandpermissions",
                        "client-category":"clientcategories",
                        "client-docs":"clientdocument",
                        "crew-docs":"crewdocuments",
                        "dynamic-fields-clients":"dynfieldforclient",
                        "dynamic-fields-crew":"dynfieldforcrew",
                        "vehicle-info":"vehicleinfo",
                        "skills":"skills",
                        "rate-card":"masterratecard",
                        "pay-levels":"paylevels",
                        "other-expenses":"otherexpenses",
                        "cancel-reasons":"eventcancelreasons",
                        "csv-templates":"csvtemplatesdownload",
                        "invite-friend":"inviteafriend",
                        "sectors":"sector",
                        "sub-sectors":"subsector",
                        "dynamic-fields-affiliates":"dynfieldforaffiliate",
                        "omnu-points":"performancepoints",
                        "omnu-point-settings":"mnyhandspointsagainstpp",
                        "cancel-reasons":"eventcancelreasons",
                        "terms":"termsandconditions",
                        "certificates":"certificates"
                    }
const loginAsPageList = ["quotes","events","schedule"]
const loginAsUrlList = ["schedule-view","schedule-shift","quotes","events"]

export function checkPermissions(page, modulePermission) {
    let userGroupData = userGroupUrlCheck(window.location);
    let userGroup = ''; 
    let group = '';
    let login_as_sa_user = 0;
    if(userGroupData!==undefined) {
        userGroup = userGroupData.user_group;
        login_as_sa_user = userGroupData.login_as_sa_user;
    }  
    if(userGroup===LOGIN_AFFILIATE_GROUP){
        group = 'affiliate';

    }else if(userGroup===LOGIN_SUPER_ADMIN_GROUP){
        group = 'superadmin';
    }else{
        return true;
    }
    if(login_as_sa_user === 1 && loginAsPageList.indexOf(page) != -1){
        return true;
    }
   
	// let userGroupData  = getUserGroupData('affiliate');
 //    if(userGroupData===null){
 //    	userGroupData  = getUserGroupData('client');
 //    	if(userGroupData === null){
 //    		return true;
 //    	}else{
 //    		group = 'client';
 //    	}
 //    }else{
 //    	group = 'affiliate';
 //    }
    let permissions = userGroupData && userGroupData.user_permissions ? userGroupData.user_permissions : [];
    let flag = false;
    if(page=='skills'){
        console.log(permissions);
    }
    if(permissions){
    	permissions.map((permission) => {
    		let arrPerm = permission.codename.split("_");
    		if(arrPerm[0] == "omnu" && arrPerm[1] == group 
    						&& arrPerm[2] == page 
    						&& arrPerm[3] == modulePermission){
    			flag = true;
    			return;

    		}
    	})
    }
    
    return flag;
}

export function checkUrlPermissions(pathName) {
    let userGroupData = userGroupUrlCheck(window.location);
    let userGroup = ''; 
    let group = '';
    let login_as_sa_user = 0;
    if(userGroupData!==undefined){
        userGroup = userGroupData.user_group;
        login_as_sa_user = userGroupData.login_as_sa_user; 
    } 

    if(userGroup===LOGIN_AFFILIATE_GROUP){
        group = 'affiliate';

    }else if(userGroup===LOGIN_SUPER_ADMIN_GROUP){
        group = 'super';
    }else{
        return true;
    } 
	// let userGroupData  = getUserGroupData('affiliate');
 //    if(userGroupData===null){
 //    	userGroupData  = getUserGroupData('client');
 //    	if(userGroupData === null){
 //    		return true;
 //    	}else{
 //    		group = 'client';
 //    	}
 //    }else{
 //    	group = 'affiliate';
 //    }
    let permissions = userGroupData && userGroupData.user_permissions?userGroupData.user_permissions:[];
    let flag = false;
    let arrPath = pathName.split("/")
    let page = arrPath[2];
    if(loginAsUrlList.indexOf(arrPath[2]) !== -1 && login_as_sa_user === 1){
        return true;
    }
    if(permissionList.indexOf(arrPath[2]) == -1 && settingArray.indexOf(arrPath[2]) == -1){
    	return true;
    }
    if(permissions){
    	permissions.map((permission) => {
    		let arrPerm = permission.codename.split("_");
    		// if(settingArray.indexOf(arrPath[2]) !=-1){
    		// 	page = "settings";
    		// }else 
            if(page in moduleObject){
                page = moduleObject[page]
            }
    		if(arrPerm[0] == "omnu" && arrPath[1] == group 
    						&& arrPerm[2] == page 
    						&&(arrPerm[3] == "view")){
    			flag = true;
                return;

    		}
    	})
    }
    
    return flag;
}